import "./Home.sass";

import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { auth, logout } from "../Firebase/Firebase";
import { useAuthState } from "react-firebase-hooks/auth";

function Home() {
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
  }, [user, loading]);

  return (
    <div className="Home">
      <span>
      	  <button
	        className="Common-button Home-button"
	        onClick={() => navigate("/profile")}
	      >
	        Profile
	      </button>
	      <button
	        className="Common-button Logout-button"
	        onClick={() => logout()}
	      >
	        Logout
	      </button>
      </span>
      <div className="Home-title">Hume AI Portal</div>
      <div className="Home-intro">
        <span className="Home-intro-section">Welcome to the Hume AI demo portal.</span>
      </div>
    </div>
  );
}

export default Home;